import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { SiLeetcode, SiHuggingface } from 'react-icons/si';
import {
  FaLinkedin,
  FaGithub,
  FaMediumM,
 
  FaGoogle,
  FaInstagram,
 
  FaBriefcase,
  FaProjectDiagram,
  FaSchool,
  FaCode,
  FaCertificate,
  FaUserAlt,
  FaHome,
  FaBuilding,
  FaBrain,
  FaSatelliteDish,
 // FaSatelliteDish,
 // FaRocket,
 // FaMicrochip
} from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/footer.css'; // Ensure this file exists for custom styles

const Footer = () => {
  const [visitorsCount, setVisitorsCount] = useState(0);

  useEffect(() => {
    const count = parseInt(localStorage.getItem('visitorsCount')) || 0;
    localStorage.setItem('visitorsCount', count + 1);
    setVisitorsCount(count + 1);
  }, []);

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer mt-auto py-4 mt-2 bg-dark text-white">
      <Container>
        <Row>
          {/* About Me Column */}
          <Col lg={3} md={6} className="mb-4">
            <h3 className="fw-bold" style={{
              background: 'linear-gradient(90deg, #00f260, #0575E6)',
              WebkitBackgroundClip: 'text',
              color: 'transparent'
            }}>
              Bandaru Mahesh
            </h3>
            <hr />
            <p className="fw-bold text-warning" style={{ fontSize: '0.9rem' }}>
              With a deep passion for technology and innovation, I combine a strong technical background with entrepreneurial vision to deliver cutting-edge solutions and services across multiple industries, helping them stay competitive and future-ready.
            </p>
          </Col>

          {/* Quick Links Column */}
          <Col lg={3} md={6} className="mb-4">
            <h5 className='text-start fw-bold text-info'>Company Links  <span className='text-secondary fs-6' >Startups</span></h5>
            <hr />
            <ul className="list-unstyled text-start text-muted ">
              <li><FaBuilding /><a href="https://olewintechsolutions.com" className="text-white ms-2" target='_blank' rel='noreferrer'>OlewinTechSolutions</a></li>
                {/* <li><FaRocket /><a href="/Quantum" className="text-white ms-2" >Olewin-Q</a></li>  */}
              <li><FaBrain /><a href= "https://olewinai.com/" className="text-white ms-2" target='_blank' rel='noreferrer' >OlewinAI</a></li>
                <li><FaSatelliteDish /><a href="https://olewinacademy.com/" className="text-white ms-2" >OlewinAcademy</a></li> 
                <li><FaSatelliteDish /><a href="https://geointelli-q.web.app/" className="text-white ms-2" >Geo-Intelli-Q</a></li> 
                {/* <li><FaMicrochip /><a href="/olewin" className="text-white ms-2" >OlewinTec</a></li>  */}
            </ul>
          </Col>

          {/* Portfolio Details Column */}
          <Col lg={3} md={6} className="mb-4">
            <h5 className='text-start fw-bold text-info'>My Portfolio Details</h5>
            <hr />
            <ul className="list-unstyled text-start">
              <li><FaHome /><a href="/" className="text-white ms-2">Home</a></li>
              <li><FaSchool /><a href="/Education" className="text-white ms-2">Education</a></li>
              <li><FaBriefcase /><a href="/experience" className="text-white ms-2">Expertise Skills</a></li>
              <li><FaCode /><a href="/skills" className="text-white ms-2">Technical Skills</a></li>
              <li><FaProjectDiagram /><a href="/projects" className="text-white ms-2">Projects</a></li>
              <li><FaCertificate /><a href="/certificates" className="text-white ms-2">Certifications</a></li>
              <li><FaUserAlt /><a href="/about" className="text-white ms-2">About Me</a></li>
              {/* <li><FaBlog /><a href="/blog" className="text-white ms-2">Blogs</a></li> */}
            </ul>
          </Col>

          {/* Social Media Column */}
          <Col lg={3} md={6} className="mb-4">
            <h5 className='fw-bold text-info text-start'>Connect On</h5>
            <hr />
            <div className="d-flex flex-wrap">
              <a href="https://www.linkedin.com/in/bandaru-mahesh-b1a12532a" target='_blank' rel="noopener noreferrer" className="text-white mx-2" title="LinkedIn" aria-label="LinkedIn Profile">
                <FaLinkedin size={25} />
              </a>
              <a href="https://github.com/olewintechsolutions" target='_blank' rel="noopener noreferrer" className="text-white mx-2" title="GitHub">
                <FaGithub size={25} />
              </a>
              <a href="https://www.instagram.com/bandaru_mahesh333/" target='_blank' rel="noopener noreferrer" className="text-white mx-2" title="Instagram">
                <FaInstagram size={25} />
              </a>
              {/* <a href="https://www.youtube.com/@OlewinAcademy" target='_blank' rel="noopener noreferrer" className="text-white mx-2" title="YouTube">
                <FaYoutube size={25} />
              </a> */}
              <a href="https://huggingface.co/bandarumahesh333" target='_blank' rel="noopener noreferrer" className="text-white mx-2" title="Hugging Face">
                <SiHuggingface size={25} />
              </a>
            </div>
            <div className="d-flex flex-wrap my-3">
              <a href="mailto:bandarumahesh2024@gmail.com" className="text-white mx-2" title="Google">
                <FaGoogle size={25} />
              </a>
              <a href="https://bandarumahesh.medium.com/" target='_blank' rel="noopener noreferrer" className="text-white mx-2" title="Medium">
                <FaMediumM size={25} />
              </a>
              {/* <a href="https://twitter.com/@olewintech" target='_blank' rel="noopener noreferrer" className="text-white mx-2" title="Twitter/X">
                <FaTwitter size={25} />
              </a> */}
              <a href="https://leetcode.com/u/LEF5kPLxjG/" target='_blank' rel="noopener noreferrer" className="text-white mx-2" title="LeetCode">
                <SiLeetcode size={25} />
              </a>
            </div>
          </Col>
        </Row>

        {/* Footer Bottom Section */}
        <hr className="my-2" />
        <Row className="align-items-center">
          <Col md={4} className="text-start mb-2">
            <p>
              <a href="/terms" className='text-light'>Terms & Conditions</a> | 
              <a href="/copy" className='text-light'> Copyright</a> | 
              <a href="/policy" className='text-light'> Policy</a>
            </p>
          </Col>
          <Col md={4} className="text-center mb-2">
            <p>Bandaru Mahesh</p>
          </Col>
          <Col md={4} className="text-end mb-2">
            <p>Visitors: {visitorsCount}</p>
          </Col>
        </Row>

        <div className="text-center py-2">
          <p className="mb-0">&copy; All Rights Reserved | {currentYear}</p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
